var render = function () {
  var _vm$response$product$;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-page p",
    attrs: {
      "data-e2e-product": _vm.response.product.id
    }
  }, [_c('div', {
    staticClass: "product-page__content"
  }, [_c('div', {
    staticClass: "product-page__header"
  }, [_c('Breadcrumb', {
    attrs: {
      "list": _vm.response.breadcrumb,
      "is-last-link-active": _vm.isSubPage,
      "shrink-on-mobile": ""
    }
  }), _vm._v(" "), _vm.getTitle ? _c('h1', {
    staticClass: "product-page__title"
  }, [_vm._v("\n        " + _vm._s(_vm.getTitle) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-page__row"
  }, [_c('UIActionEntity', {
    attrs: {
      "get": _vm.$api.user.addUserAchievement
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var get = _ref.get;
        return [_c('span', {
          staticClass: "product-page__share link link_grey link_wu",
          on: {
            "click": function ($event) {
              _vm.socialShareStore.enableSocialShare({
                title: _vm.response.product.name
              });

              if (_vm.isUser) { get({
                code: 'ambassador05ru'
              }); }
            }
          }
        }, [_vm._v("\n            Поделиться\n          ")])];
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "product-page__nav"
  }, [_c('div', {
    staticClass: "product-page__nav-slider"
  }, [_c('ul', {
    staticClass: "product-page__nav-list"
  }, [_c('li', {
    staticClass: "product-page__nav-item"
  }, [_c('nuxt-link', {
    staticClass: "link link_wu product-page__nav-link",
    attrs: {
      "exact-active-class": "product-page__nav-link_active",
      "to": _vm.response.product.path
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.scrollNavigationToCenter.apply(null, arguments);
      }
    }
  }, [_vm._v("\n              О товаре\n            ")])], 1), _vm._v(" "), _vm._l(_vm.tabs, function (el, index) {
    return _c('li', {
      key: index,
      staticClass: "product-page__nav-item"
    }, [_c('nuxt-link', {
      staticClass: "link link_wu product-page__nav-link",
      attrs: {
        "active-class": "product-page__nav-link_active",
        "to": _vm.response.product.path + el.link
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.scrollNavigationToCenter.apply(null, arguments);
        }
      }
    }, [_vm._v("\n              " + _vm._s(el.name) + "\n              "), el.count ? _c('span', {
      staticClass: "product-page__nav-item-count"
    }, [_vm._v(_vm._s(el.count))]) : _vm._e()])], 1);
  })], 2)])]), _vm._v(" "), _c('NuxtChild', {
    attrs: {
      "response": _vm.response
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "product-page__sidebar"
  }, [_c('div', {
    staticClass: "product-page__sidebar-wrapper"
  }, [_c('div', {
    staticClass: "product-page__sidebar-content"
  }, [_c('div', {
    staticClass: "product-page__tools mb-15"
  }, [_c('UserTools', {
    attrs: {
      "product": _vm.response.product,
      "data-e2e": "product-user-tools"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "product-page__price-block"
  }, [_c('ProductPriceBlock', {
    attrs: {
      "offer": _vm.response.offer,
      "product": _vm.response.product,
      "is-pre-order": _vm.isPreOrder
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function () {
        return [_c('ActionCart', {
          attrs: {
            "id": _vm.response.product.id,
            "product": Object.assign({}, _vm.props.response.product, {
              id: Number(_vm.props.response.product.code)
            }),
            "source": "Карточка товара",
            "actions": {
              send: _vm.$api.cart.add
            },
            "modal": {
              image: _vm.response.product.image,
              link: _vm.response.product.path,
              name: _vm.response.product.name,
              price: _vm.response.product.price,
              category: _vm.response.product.category,
              offer: _vm.response.product.offer,
              id: _vm.response.product.id
            },
            "receive-quantity-from-api": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var add = _ref2.add,
                  error = _ref2.error,
                  loading = _ref2.loading;
              return [_c('AddToCart', {
                staticClass: "mb-9",
                attrs: {
                  "count": _vm.cartCount,
                  "error": error,
                  "type": _vm.isPreOrder ? 'preorder' : 'default',
                  "loading": loading
                },
                on: {
                  "send": function ($event) {
                    return add({
                      id: _vm.response.product.id,
                      quantity: _vm.cartCount + 1
                    });
                  }
                }
              })];
            }
          }])
        }), _vm._v(" "), !_vm.isPreOrder && _vm.price && _vm.price >= 3000 && _vm.price <= 200000 ? _c('LazyLoan', {
          staticClass: "mb-8 mt-15",
          attrs: {
            "product": _vm.response.product
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref3) {
              var loading = _ref3.loading,
                  enableCalculation = _ref3.enableCalculation;
              return [_c('InfoBlockInstallment', {
                attrs: {
                  "loading": loading,
                  "product": _vm.response.product
                },
                on: {
                  "enable": function ($event) {
                    return enableCalculation();
                  }
                }
              })];
            }
          }], null, false, 3125406188)
        }) : _vm._e(), _vm._v(" "), _vm.response.product.isCreditAvailable && _vm.price && _vm.price >= 3000 ? _c('Button', {
          staticClass: "mb-8",
          attrs: {
            "theme": "blue",
            "icon": "calendar",
            "fluid": ""
          },
          on: {
            "click": _vm.onClickBuyCredit
          }
        }, [_vm._v("\n                Купить в кредит\n              ")]) : _vm._e(), _vm._v(" "), _c('UIActionEntity', {
          attrs: {
            "get": _vm.$api.product.buyOneClick
          },
          on: {
            "success": _vm.onSuccessQuickOrder
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref4) {
              var get = _ref4.get,
                  status = _ref4.status,
                  responseQuickOrder = _ref4.response;
              return [_c('QuickOrderToggle', {
                attrs: {
                  "product-id": _vm.response.product.id,
                  "status": status,
                  "response": responseQuickOrder
                },
                on: {
                  "send": function ($event) {
                    get($event);

                    _vm.emitter.emit('fast-ordering', {
                      phone: $event.number,
                      product: _vm.response.product
                    });
                  }
                }
              })];
            }
          }])
        })];
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _vm.response.product.availability.length && _vm.response.product.delivery.length ? [_c('DeliveryType', {
    staticClass: "mt-8",
    attrs: {
      "availability": _vm.response.product.availability,
      "delivery": _vm.response.product.delivery
    }
  })] : _vm._e(), _vm._v(" "), (_vm$response$product$ = _vm.response.product.price) !== null && _vm$response$product$ !== void 0 && _vm$response$product$.common ? _c('div', {
    staticClass: "product-page__cheaper-wrap"
  }, [_c('Toggle', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref5) {
        var onClick = _ref5.onClick,
            isActive = _ref5.isActive;
        return [_c('div', {
          staticClass: "product-page__cheaper",
          class: [{
            'product-page__cheaper_active': isActive
          }],
          attrs: {
            "data-e2e": "cheaper-button"
          }
        }, [_c('div', {
          staticClass: "product-page__cheaper-text",
          on: {
            "click": onClick
          }
        }, [_vm._v("\n                  Нашли дешевле?\n                ")]), _vm._v(" "), isActive ? _c('div', {
          staticClass: "product-page__cheaper-content"
        }, [_c('nuxt-link', {
          staticClass: "link link_blue fz-17",
          attrs: {
            "to": "/sales/garantiya-luchshey-tseny/"
          }
        }, [_vm._v("\n                    Гарантия лучшей цены\n                  ")]), _vm._v(" "), _c('p', {
          staticClass: "p mb-8 mt-9"
        }, [_vm._v("\n                    Оставьте ссылку на товар, который вы нашли, и телефон, мы вам перезвоним.\n                  ")]), _vm._v(" "), _c('UIActionEntity', {
          attrs: {
            "get": _vm.$api.product.foundCheaper
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref6) {
              var get = _ref6.get,
                  status = _ref6.status,
                  responseFoundCheaper = _ref6.responseFoundCheaper;
              return [_c('FoundCheaper', {
                attrs: {
                  "product-id": _vm.response.product.id,
                  "status": status,
                  "response": responseFoundCheaper
                },
                on: {
                  "send": function ($event) {
                    get($event), _vm.emitter.emit('submit-form-data', {
                      phone: $event.number
                    });
                  }
                }
              })];
            }
          }], null, true)
        })], 1) : _vm._e()])];
      }
    }], null, false, 1845751861)
  })], 1) : _vm._e()], 2)])]), _vm._v(" "), _c('SearchSemantic', {
    attrs: {
      "data": {
        '@context': 'http://schema.org',
        '@type': 'Product',
        'name': _vm.response.product.name,
        'image': _vm.response.product.image,
        'description': _vm.response.meta.element.description,
        'sku': _vm.response.product.code,
        'url': _vm.response.product.path,
        'brand': {
          '@type': 'Brand',
          'name': 'Интернет-магазин «05.ru»',
          'logo': require('~/assets/images/logo-80px.svg')
        },
        'offers': {
          '@type': 'Offer',
          'price': _vm.price,
          'priceCurrency': 'RUB',
          'availability': 'https://schema.org/InStock',
          'url': _vm.response.product.path,
          'seller': {
            '@type': 'Organization',
            'name': 'Интернет-магазин «05.ru»'
          }
        },
        'aggregateRating': {
          '@type': 'AggregateRating',
          'ratingValue': '5.0',
          'bestRating': '5.0',
          'worstRating': '1.0',
          'ratingCount': '187'
        }
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }